import { useState } from 'react';

import { FormControl, MenuItem, Select } from '@mui/material';

export default function AxlSelect({ theme = 'main', ...props }) {
  const [value, setValue] = useState(props.defaultValue);

  const handleChange = ({ target: { value } }) => {
    setValue(value);
    if (props.onChange) props.onChange(value);
  };

  return (
    <FormControl fullWidth size="small">
      <Select value={value} onChange={handleChange} variant="outlined" {...props}>
        {props.options.length ? (
          props.options.map((option, index) => (
            <MenuItem key={`option-${index}`} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem key={`option-0`}>{`No value`}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
